module.exports = __webpack_public_path__ + "static/media/speech-bubble.02cc08a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/OrganizationalUnit/speech-bubble.svg
// module id = 2413
// module chunks = 0